// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"163":"map","251":"begeleider-setup","688":"student-setup","930":"setup"}[chunkId] || chunkId) + "." + {"163":"bf3f71fc","251":"3f08a184","365":"ca4eff28","688":"65dfdac5","930":"40f3d6f9"}[chunkId] + ".js";
};